/** Login identifier: roster usernames (orlin_wetzker) or dev emails (demo@localhost.dev). */
export function isValidLoginIdentifier(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed.length < 3) {
    return false;
  }
  if (trimmed.includes('@')) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  }
  return /^[a-zA-Z0-9._-]+$/.test(trimmed);
}

export const LOGIN_IDENTIFIER_RULES = [
  { required: true, message: 'Please enter your email or username' },
  {
    validator: (_: unknown, value: string) =>
      !value || isValidLoginIdentifier(value)
        ? Promise.resolve()
        : Promise.reject(new Error('Enter a valid email or username')),
  },
] as const;
